import React, { useMemo } from "react"
import useDebounceQueryParams from "magik-react-hooks/useRouterDebounceQueryParams"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import Layout from "../../components/Layout/Layout"
import Button from "@material-ui/core/Button"
import ModalDelete from "../../components/Modals/ModalDelete"
import { Card, CircularProgress, Grid, IconButton, InputAdornment, TextField } from "@material-ui/core"
import { GetApp, RotateLeft, AddCircle, Cancel } from "@material-ui/icons"
import { TagState } from "../../state/tags"
import ListTags from "../../components/Tags/ListTags"
import ModalFormTag from "../../components/Tags/ModalFormTag"
import { useRunRj } from "react-rocketjump"
import qs from "query-string"
import { useExportToken } from "../../state/exportToken"
import { useSelectedAzienda } from "../../SelectedAzienda"
import { isMobile } from "react-device-detect"

export default function Tags() {
  const [{ selectedAzienda }] = useSelectedAzienda()
  const [
    queryParams,
    setQueryParams,
    debQueryParams,
    setDebQueryParams,
  ] = useDebounceQueryParams()

  const [modalCreate, actionsModalCreate] = useModalTrigger()
  const [modalUpdate, actionsModalUpdate] = useModalTrigger()
  const [modalDelete, actionsModalDelete] = useModalTrigger()
  const { value: deleteTag } = modalDelete

  const onUpdate = (tag) => actionsModalUpdate.open(tag)
  const onDelete = (tag) => actionsModalDelete.open(tag)

  const filters = useMemo(() => {
    return { ...debQueryParams, azienda: selectedAzienda.id }
  }, [debQueryParams, selectedAzienda])

  const [
    { list, loading, pagination },
    { addTag, updateTag, removeTag },
  ] = useRunRj(TagState, [filters], false)

  const columnProps = {
    value: queryParams.ordering,
    onChange: (value) => setDebQueryParams({ ordering: value }),
  }

  const isProductionEnv = process.env.NODE_ENV === "production"
  const host = isProductionEnv ? window.location.host : "localhost:8000"
  const protocol = window.location.protocol

  const exportToken = useExportToken()

  const linkCsv = useMemo(() => {
    return `${protocol}//${host}/api/tags-export/csv?${qs.stringify({
      ...filters,
      export_token: exportToken,
    })}`
  }, [exportToken, filters, host, protocol])

  const linkPdf = useMemo(() => {
    return `${protocol}//${host}/api/tags-export/pdf?${qs.stringify({
      ...filters,
      export_token: exportToken,
    })}`
  }, [exportToken, filters, host, protocol])

  return (
    <Layout title="Tags">
      <div>
        <Card className="card-filters">
          <Grid container>
            <Grid item xs={12} md={6}>
              <div>
                <TextField
                  size="small"
                  placeholder="Cerca..."
                  value={queryParams.search ?? ""}
                  onChange={(e) =>
                    setDebQueryParams({
                      search: e.target.value,
                      page: 1,
                    })
                  }
                  style={{ width: isMobile ? '100%' : undefined}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled={!queryParams.search}
                          aria-label="toggle password visibility"
                          onClick={() => setQueryParams(() => {})}
                          edge="end"
                        >
                          <Cancel color={!queryParams.search ? undefined  : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  id="outlined-basic"
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                className={
                  isMobile ? "d-flex justify-content-center pt-5" : "text-right"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GetApp />}
                  href={linkCsv}
                >
                  Excel
                </Button>
                <Button
                  style={{ marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  target="_blank"
                  startIcon={<GetApp />}
                  href={linkPdf}
                >
                  Pdf
                </Button>
              </div>
            </Grid>
          </Grid>
        </Card>
        <Card className="card-add">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircle />}
            onClick={() => actionsModalCreate.open()}
          >
            Aggiungi Tag
          </Button>
        </Card>
        {list === null && loading && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress color="primary" />
          </div>
        )}
        {list && (
          <ListTags
            pagination={pagination}
            columnProps={columnProps}
            tags={list}
            onUpdate={onUpdate}
            onDelete={onDelete}
          />
        )}
        <ModalFormTag
          save={(tag) => {
            return addTag
              .onSuccess(() => actionsModalCreate.close())
              .asPromise({ ...tag, azienda: selectedAzienda.id })
          }}
          isOpen={modalCreate.isOpen}
          toggle={actionsModalCreate.toggle}
          onExited={actionsModalCreate.onClosed}
        />
        <ModalFormTag
          save={(tag) => {
            return updateTag
              .onSuccess(() => actionsModalUpdate.close())
              .asPromise({ ...tag, azienda: selectedAzienda.id })
          }}
          tag={modalUpdate.value}
          isOpen={modalUpdate.isOpen}
          toggle={actionsModalUpdate.toggle}
          onExited={() => {
            actionsModalUpdate.onClosed()
          }}
        />
        <ModalDelete
          isOpen={modalDelete.isOpen}
          toggle={actionsModalDelete.toggle}
          title={deleteTag ? `Rimuovere ${deleteTag.nome}?` : null}
          text={
            deleteTag
              ? `Sei sicuro di voler eliminare il tag ${deleteTag.nome}?`
              : null
          }
          onDelete={() => {
            return removeTag
              .onSuccess(() => actionsModalDelete.close())
              .asPromise(modalDelete.value)
          }}
          onExited={actionsModalDelete.onClosed}
        />
      </div>
    </Layout>
  )
}
